import '@fontsource-variable/bricolage-grotesque'
import '@fontsource/ibm-plex-mono/400.css'
import '@fontsource/ibm-plex-sans/400.css'
import '@fontsource/ibm-plex-sans/500.css'
import '@fontsource/ibm-plex-sans/600.css'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'

import { App } from './App'
import { GlobalStyle } from './components/GlobalStyle'
import { getBasename, getPathLanguage, getPreferredLanguageUrl, I18nProvider } from './i18n'
import { store } from './store'

const preferredLanguageUrl = getPreferredLanguageUrl(window.location)
const language = getPathLanguage(window.location.pathname)

if (preferredLanguageUrl) {
  window.location.replace(preferredLanguageUrl)
} else {
  createRoot(document.getElementById('root') as HTMLElement).render(
    <StrictMode>
      <Provider store={store}>
        <I18nProvider language={language}>
          <BrowserRouter basename={getBasename(language)}>
            <GlobalStyle />
            <App />
          </BrowserRouter>
        </I18nProvider>
      </Provider>
    </StrictMode>
  )
}
